import React from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";

import { Divider, StyledSubHeader, StyledGridContainer, StyledFormikInputText, StyledFormikInputTypeAhead, StyledHeaderContainer, StyledHeader, StyledTermSheetButonBlue, StyledButtonCentered } from "./section.styles";
import { renderHedges, addHedgeRow } from "./section.util";

const InterestRateProtection = ({ formik }) => {
  const { values, setValues, setFieldValue } = formik;

  const prepaymentTypes = values && values.ancillary && values.ancillary.prepaymentTypes ? values.ancillary.prepaymentTypes : [];

  return (
    <Grid container>
      <StyledHeaderContainer item xs={12}><StyledHeader>Interest Rate Protection</StyledHeader></StyledHeaderContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="requiredHedgeId"
          name="hedgeRequirements.requiredHedgeId"
          label="Hedge Type"
          options={[
            { id: "fc0fa822-733b-11e9-b768-0242ac120002", name: "Cap", label: "Cap", value: "fc0fa822-733b-11e9-b768-0242ac120002" },
            { id: "fe1fa999-733b-11e9-b768-0242ac120002", name: "Swap", label: "Swap", value: "fe1fa999-733b-11e9-b768-0242ac120002" },
            { id: "cdefa777-733b-11e9-b768-0242ac120002", name: "Any Lender Approved", label: "Any Lender Approved", value: "cdefa777-733b-11e9-b768-0242ac120002" }
          ]}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => { }}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
      <StyledGridContainer item xs={12}>
        <StyledFormikInputText
          name={"hedgeRequirements.pricingRequirements"}
          label={"Pricing Requirements"}
          variant={"filled"}
          multiline
        />
      </StyledGridContainer>

      <StyledHeaderContainer item xs={12}><StyledSubHeader>Hedges</StyledSubHeader></StyledHeaderContainer>

      {renderHedges(values, setValues, setFieldValue)}

      <StyledTermSheetButonBlue onClick={() => addHedgeRow(values, setValues)}>
        <StyledButtonCentered>
          Add New Hedge
        </StyledButtonCentered>
      </StyledTermSheetButonBlue>
      <Divider />
    </Grid>
  );
};

export default compose(connect)(InterestRateProtection);
